import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faLockOpen } from "@fortawesome/free-solid-svg-icons";

const getLockIcon = (condition) => (
    <FontAwesomeIcon
        icon={condition && condition.closed ? faLock : faLockOpen}
        className={condition && condition.closed ? "text-success" : "text-danger"}
    />
);

export default getLockIcon;



// WEBPACK FOOTER //
// ./src/views/pages/bikes/helpers/get-lock-icon.js